import { ChevronRightIcon } from "@bp/ui-components";
import { Fragment } from "react";
import { Link, useMatches } from "react-router-dom";
import { useCrumbTitle } from "../../contexts/CrumbTitleContext";

export type Crumb = { label: string; to?: string };

/** Attach to a route as `handle: { crumb }` so the Breadcrumb can render it. */
export type RouteCrumbHandle = {
  crumb?: (data: unknown) => Crumb;
};

export function Breadcrumb() {
  const matches = useMatches();
  const detailTitle = useCrumbTitle();
  const crumbs: Crumb[] = matches
    .map((m) => {
      const handle = m.handle as RouteCrumbHandle | undefined;
      return handle?.crumb ? handle.crumb(m.data) : null;
    })
    .filter((c): c is Crumb => c !== null);

  if (crumbs.length === 0) {
    return null;
  }

  return (
    <nav
      aria-label="Breadcrumb"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 7,
        fontSize: 12,
        color: "var(--color-grey)",
        marginBottom: 14,
        flexWrap: "wrap",
      }}
    >
      {crumbs.map((c, i) => {
        const last = i === crumbs.length - 1;
        const label = last && detailTitle ? detailTitle : c.label;
        return (
          <Fragment key={`${c.label}-${i}`}>
            {i > 0 && (
              <ChevronRightIcon
                style={{ width: 12, height: 12, color: "var(--color-grey-lighter)" }}
              />
            )}
            {c.to && !last ? (
              <Link to={c.to} style={{ color: "var(--color-grey)" }}>
                {label}
              </Link>
            ) : (
              <span style={{ color: "var(--color-text)" }}>{label}</span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
